import { gql } from "@apollo/client"

export const TOURNAMENT_PLAYER_REGISTER = gql`
  mutation TournamentPlayerRegister(
    $TournamentPlayerRegisterInput: TournamentPlayerRegisterInput!
  ) {
    TournamentPlayerRegister(input: $TournamentPlayerRegisterInput) {
      status {
        success
        name
        detail
      }
      rounds
      TournamentPlayer {
        id
        personId
        raceId
        Person {
          id
          avatar
          fullName
          urlAvatar
          email
          emailValid
          code
        }
      }
      TournamentOrganizers {
        id
        personId
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
        }
      }
    }
  }
`
